import apiWrapper from '../../../../common/api/api-wrapper';
import { IAPIErrorContent } from '../../../../common/api/type-def';

import {
	IRecentViewedRegulation,
	IRecentViewedRegulationData,
	IRegulationFinalRule,
	IRegulationIncomingDataResponse,
	IRegulatoryActivityGraph,
	IRegulatoryRiskGraph,
	IRegulatoryRiskGraphParams,
} from './type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL, REACT_APP_USER_SERVICE_URL } =
	process.env;
export const getRecentViewedRegulations = async (
	params: IRecentViewedRegulation,
) => {
	const resp = await apiWrapper.get<IRecentViewedRegulationData[]>(
		`${REACT_APP_USER_SERVICE_URL}/activity/${params.userId}`,
	);
	return resp;
};

export const getRegulatoryRiskData = async (
	params: IRegulatoryRiskGraphParams,
) => {
	const resp = await apiWrapper.get<IRegulatoryRiskGraph, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/relation-mapping/citation/priority-count?startDate=${params.startDate}&endDate=${params.endDate}`,
	);
	return resp;
};

export const getRegulatoryActivityData = async (
	params: IRegulatoryRiskGraphParams,
) => {
	const resp = await apiWrapper.get<
		IRegulatoryActivityGraph[],
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/risk/byagency/count?startDate=${params.startDate}&endDate=${params.endDate}`,
	);
	return resp;
};

export const getRegulationIncomingTableData = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const sort = sortKey !== '' ? `${sortKey},${sortDirection}` : '';
	const resp = await apiWrapper.get<
		IRegulationIncomingDataResponse,
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/incoming-regulation?page=${params?.pageNumber}&size=${params?.pageSize}&sort=${sort}`,
	);
	return resp;
};

export const getRegChangeTableData = async (
	data: any,
	params: any,
	type: string,
) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const sort = sortKey !== '' ? `${sortKey},${sortDirection}` : '';
	const regURL = `${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search`;
	const reqURL =
		type === 'incoming'
			? `${regURL}/search?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sort=${sort}`
			: `${regURL}/regulation/change?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sort=${sort}&filterType=${type}`;
	const resp = await apiWrapper.post<any, IAPIErrorContent>(reqURL, data);
	return resp;
};

export const getRegulationListCount = async (data: any) => {
	const resp = await apiWrapper.post<IRegulationFinalRule>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search/regulation/change-details`,
		data,
	);
	return resp;
};
